import { render } from "./ReportGroupList.vue?vue&type=template&id=f6f710a0"
import script from "./ReportGroupList.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportGroupList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/ReportGroupList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6f710a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6f710a0', __exports__)) {
    api.reload('f6f710a0', __exports__)
  }
  
  module.hot.accept("./ReportGroupList.vue?vue&type=template&id=f6f710a0", () => {
    api.rerender('f6f710a0', render)
  })

}


export default __exports__